import { RootState } from "@customTypes/mainState";
import { Store, AnyAction, Dispatch } from "redux";

class ReduxStoreHelper {
  private store: Store<RootState> | undefined;

  constructor(store?: Store<RootState>) {
    this.store = store;
  }

  getStore() {
    return this.store;
  }

  dispatch(action: (payload: Record<string, never>) => AnyAction, payload: Record<string, never>) {
    return (this.store?.dispatch as Dispatch<AnyAction>)(action(payload));
  }

  getState() {
    return this.store?.getState();
  }

  setStore(store: Store<RootState>) {
    this.store = store;
  }
}

const reduxStoreHelper = new ReduxStoreHelper();
export default reduxStoreHelper;
